export const getCustomerRole = (params) => {
    const { orgId, managerIds: managerOrgId = new Set(), colleagueIds: colleagueOrgId = new Set() } = params;
    if (!orgId) {
        return 'other';
    }
    if (managerOrgId.has(orgId)) {
        return 'manager';
    }
    if (colleagueOrgId.has(orgId)) {
        return 'colleague';
    }
    return 'openSea';
};
export const getCustomerRoleByMangerIds = (params) => {
    const { currentAccountId, managerIds, roleAccountIds = [], viewRole } = params;
    if (!currentAccountId) {
        return 'external';
    }
    if (!(managerIds === null || managerIds === void 0 ? void 0 : managerIds.length)) {
        return 'openSeaCustomer';
    }
    if (!viewRole) {
        return 'colleagueCustomerNoAuth';
    }
    if (managerIds.includes(currentAccountId)) {
        return roleAccountIds.includes(currentAccountId) ? 'myCustomer' : 'colleagueCustomerNoAuth';
    }
    return managerIds.some(id => roleAccountIds.includes(id)) ? 'colleagueCustomer' : 'colleagueCustomerNoAuth';
};
